import axios from 'axios';
import { useCookies } from 'react-cookie';
import { useMutation, useQuery } from 'react-query';
import { DELETE, POST, PUT, login, profile } from 'utils';
import { api } from 'utils/apiRoutes';
import instance from 'utils/axiosConfig';
const useAuth = () => {
  const [cookies, setCookie, removeCookie] = useCookies([
    'access_token',
    'refresh_token',
  ]);
  async function getProfile() {
    let result = null;
    try {
      result = await instance.get(api.getProfile);
    } catch (error) {
      result = error;
    }
    return result;
  }

  const user = useQuery('get-profile', getProfile);

  async function register(data: object) {
    return await instance.post(api.register, data);
  }

  async function login(data: login) {
    const res = await POST(api.login, data);
    if (res.status === 200) {
      setCookie('access_token', res.data.access, { maxAge: 31536000 });
      setCookie('refresh_token', res.data.refresh, { maxAge: 31536000 });
    }
    return res;
  }

  async function logout() {
    const res = await POST(api.logOut, {
      refresh: localStorage.getItem('refresh'),
    });
    if (res.status === 200) {
      removeCookie('access_token');
      localStorage.removeItem('refresh');
    }
    return res;
  }

  async function GET(endpoint: string) {
    return await GET(endpoint);
  }

  async function getToken() {
    const res = await axios.post(api.getToken, {
      refresh: cookies.refresh_token,
    });
    if (res.status === 200) {
      setCookie('access_token', res.data.access, { maxAge: 31536000 });
      setCookie('refresh_token', res.data.refresh, { maxAge: 31536000 });
    }
    return res.data;
  }

  const loginAccount = useMutation('login', login);
  const logoutAccount = useMutation('logout', logout);

  return {
    user: user?.data?.data as profile,
    loginAccount: loginAccount.mutateAsync,
    logoutAccount: logoutAccount.mutateAsync,
    getToken: getToken,
    GET: GET,
    POST: POST,
    DELETE: DELETE,
    PUT: PUT,
    register: register,
  };
};

export default useAuth;
